import graphql__8aa1158f891903b3134f from "./__generated__/UsersMapUserMarker_userMarker.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { Marker } from "react-leaflet";

import MapElementIcon from "../MapElementIcon";
import UserMarkerTooltip from "./UserMarkerTooltip";
import {
  RESOURCES_LIST_USER_TYPE,
  useResourcesList
} from "../../ResourcesList/resourcesList";

import { selectItem } from "../../../reducers/resourcesList/selection";

const UsersMapUserMarker = props => {
  const userMarker = useFragment(UsersMapUserMarker_userMarker, props.userMarker);
  const { userId, latitude, longitude } = userMarker;
  const position = [latitude, longitude];
  const { style } = props.userMarker;
  const { zIndexOffset, iconStyle } = style;

  const { resourcesListKey } = useResourcesList();
  const dispatch = useDispatch();
  const handleMarkerClicked = useCallback(() => {
    dispatch(selectItem(resourcesListKey, userId, RESOURCES_LIST_USER_TYPE));
  }, [dispatch, resourcesListKey, userId]);

  // Do not render unlocated users
  if (!latitude || !longitude) return null;

  const icon = MapElementIcon({ iconStyle: iconStyle });

  return (
    <Marker
      className="map-debate-user"
      icon={icon}
      position={position}
      eventHandlers={{ click: handleMarkerClicked }}
      zIndexOffset={zIndexOffset}
    >
      <UserMarkerTooltip userMarker={userMarker} />
    </Marker>
  );
};

const UsersMapUserMarker_userMarker = graphql__8aa1158f891903b3134f;

export default UsersMapUserMarker;
